import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "56",
  height: "40",
  viewBox: "0 0 56 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "56",
      height: "40",
      rx: "8",
      fill: "#FFEDDB"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.288 28.192C10.84 28.192 10.496 28.064 10.256 27.808C10.016 27.552 9.896 27.2 9.896 26.752V12.328C9.896 11.864 10.024 11.512 10.28 11.272C10.536 11.016 10.888 10.888 11.336 10.888C11.736 10.888 12.048 10.968 12.272 11.128C12.512 11.272 12.728 11.528 12.92 11.896L18.848 22.864H18.08L24.008 11.896C24.2 11.528 24.408 11.272 24.632 11.128C24.856 10.968 25.168 10.888 25.568 10.888C26.016 10.888 26.36 11.016 26.6 11.272C26.84 11.512 26.96 11.864 26.96 12.328V26.752C26.96 27.2 26.84 27.552 26.6 27.808C26.376 28.064 26.032 28.192 25.568 28.192C25.12 28.192 24.776 28.064 24.536 27.808C24.296 27.552 24.176 27.2 24.176 26.752V15.64H24.704L19.664 24.832C19.504 25.104 19.336 25.304 19.16 25.432C18.984 25.56 18.744 25.624 18.44 25.624C18.136 25.624 17.888 25.56 17.696 25.432C17.504 25.288 17.336 25.088 17.192 24.832L12.104 15.616H12.68V26.752C12.68 27.2 12.56 27.552 12.32 27.808C12.096 28.064 11.752 28.192 11.288 28.192Z",
      fill: "#5C1427"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "12",
      r: "6",
      fill: "#5C1427"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "42",
      cy: "28",
      r: "6",
      fill: "#DF683A"
    }, null, -1)
  ])))
}
export default { render: render }